"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.player = exports.server = void 0;
const once_1 = __importDefault(require("@tootallnate/once"));
const server = function (serv) {
    serv.quit = async (reason = 'Server closed') => {
        serv.cleanupFunctions.forEach(fn => fn());
        await Promise.all(serv.players.map((player) => {
            player.kick(reason);
            return (0, once_1.default)(player, 'disconnected');
        }));
        serv._server.close();
        await (0, once_1.default)(serv._server, 'close');
    };
};
exports.server = server;
const player = function (player, serv, { worldFolder }) {
    player.despawnEntities = entities => player._client.write('entity_destroy', {
        entityIds: entities.map(e => e.id)
    });
    player._client.on('end', async (endReason) => {
        if (player && player.username) {
            player._unloadAllChunks();
            serv.broadcast(serv.color.yellow + player.username + ' left the game.');
            player._writeOthers('player_info', {
                action: 4,
                data: [{
                        UUID: player.uuid
                    }]
            });
            player.nearbyPlayers().forEach(otherPlayer => otherPlayer.despawnEntities([player]));
            delete serv.entities[player.id];
            player.emit('disconnected', endReason);
            const index = serv.players.indexOf(player);
            if (index > -1) {
                serv.players.splice(index, 1);
            }
            delete serv.uuidToPlayer[player.uuid];
        }
        player.save();
    });
};
exports.player = player;
